import { Chip, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { HubHookFormSelectV2 } from "../../components/HubHookFormSelectV2";

export const StyledChip = styled(Chip)({
  fontSize: 12,
  fontWeight: 500,
  height: "20px",
});

export const StyledSideStack = styled(Stack, {
  shouldForwardProp: (prop) => !["dark"].includes(prop),
})(({ theme, dark }) => ({
  gap: "25px",
  width: "100%",
  padding: "25px",
  "::-webkit-scrollbar": {
    display: "none",
  },
  ...(dark
    ? {
        backgroundColor: theme.palette.hubColors.greyLightest,
        borderLeft: "1px solid",
        borderColor: theme.palette.hubColors.greyLight,
      }
    : {}),
}));

export const StyledFormStack = styled(Stack)({
  display: "grid",
  gridTemplateColumns: "2fr 1fr",
  width: "100%",
  height: "100%",
});

const defaultTableStyle = {
  display: "grid",
  alignItems: "center",
  ".MuiInputBase-root": {
    padding: "7px",
    svg: {
      marginRight: "0px",
    },
  },
  ".MuiFormControl-root, .MuiInputBase-root": {
    height: "100%",
  },
  ".MuiInputBase-root, input": {
    borderRadius: 0,
    backgroundColor: "transparent !important",
  },
};

export const StyledWorkOrderStack = styled(Stack, {
  shouldForwardProp: (prop) => !["highlight", "disableBorder"].includes(prop),
})(({ theme, highlight, disableBorder }) => ({
  gridTemplateColumns: `repeat(3, 1fr) 100px 25px`,
  ...(disableBorder
    ? {}
    : {
        borderBottom: "1px solid",
        borderRight: "1px solid",
        borderLeft: "1px solid",
        borderColor:
          theme.palette.hubColors[highlight ? "mainFocusLight" : "greyLight"],
      }),
  ...(highlight ? {} : { backgroundColor: theme.palette.hubColors.white }),
  ":hover": {
    backgroundColor:
      theme.palette.hubColors[highlight ? "mainFocusLightest" : "greyLightest"],
  },
  fieldset: {
    borderWidth: 0.5,
    borderColor:
      theme.palette.hubColors[highlight ? "mainFocusLight" : "greyLight"],
    ...(highlight
      ? { backgroundColor: theme.palette.hubColors.mainFocusLighter2 }
      : {}),
  },
  ...defaultTableStyle,
}));

export const StyledCell = styled(Stack, {
  shouldForwardProp: (prop) => !["highlight"].includes(prop),
})(({ theme, highlight }) => ({
  height: "100%",
  width: "100%",
  alignItems: "start",
  justifyContent: "center",
  border: "0.5px solid",
  borderColor:
    theme.palette.hubColors[highlight ? "mainFocusLight" : "greyLight"],
  ...(highlight && {
    backgroundColor: theme.palette.hubColors.mainFocusLighter2,
  }),
}));

export const StyledSelect = styled(HubHookFormSelectV2)({
  ".MuiInputBase-root": {
    paddingRight: "6px !important",
  },
});
